import type { JSX } from 'react';
import { NavLink, Route, Routes } from 'react-router-dom';
import { DiagnosticsPage } from './routes/DiagnosticsPage';
import { HomePage } from './routes/HomePage';
import { NotFoundPage } from './routes/NotFoundPage';

export function App(): JSX.Element {
  return (
    <div className="app">
      <header className="app__header">
        <h1 className="app__title" data-testid="app-title">
          InventoHub
        </h1>
        <p className="app__tagline">Elite Wrestling Productions equipment inventory</p>
      </header>

      <main className="app__main">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/diagnostics" element={<DiagnosticsPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </main>

      <nav className="app__nav" aria-label="Primary">
        <NavLink to="/">Home</NavLink>
        <NavLink to="/diagnostics">Diagnostics</NavLink>
      </nav>
    </div>
  );
}
